import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { Card, CardContent } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Badge } from '@/components/ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { PageLoading } from '@/components/ui/loading';
import { formatDateTime } from '@/lib/utils';

export default function AuditLogsPage() {
  const [action, setAction] = useState('');
  const [entityType, setEntityType] = useState('');
  const { data, isLoading } = useQuery({
    queryKey: ['audit-logs', action, entityType],
    queryFn: async () => { const r = await api.get<{ data: any[] }>(`/audit-logs?action=${action}&entityType=${entityType}`); return r.data ?? []; },
  });
  if (isLoading) return <PageLoading />;
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-heading font-bold">Audit Logs</h1>
      <Card>
        <CardContent className="p-4">
          <div className="flex gap-3">
            <Input placeholder="Filter by action..." value={action} onChange={e => setAction(e.target.value)} className="w-48" />
            <Input placeholder="Filter by entity type..." value={entityType} onChange={e => setEntityType(e.target.value)} className="w-48" />
          </div>
        </CardContent>
      </Card>
      <Card><CardContent className="p-0">
        <Table>
          <TableHeader><TableRow><TableHead>Time</TableHead><TableHead>User</TableHead><TableHead>Action</TableHead><TableHead>Entity</TableHead><TableHead>Details</TableHead></TableRow></TableHeader>
          <TableBody>
            {data?.map((l: any) => (
              <TableRow key={l.id}>
                <TableCell className="text-sm">{formatDateTime(l.created_at)}</TableCell>
                <TableCell>{l.user_name || 'System'}</TableCell>
                <TableCell><Badge variant="info">{l.action}</Badge></TableCell>
                <TableCell className="text-sm">{l.entity_type} {l.entity_id ? `(${l.entity_id.slice(0, 8)}...)` : ''}</TableCell>
                <TableCell className="text-sm text-secondary max-w-xs truncate">{l.details || '-'}</TableCell>
              </TableRow>
            ))}
            {(!data || data.length === 0) && <TableRow><TableCell colSpan={5} className="text-center py-6 text-muted">No logs</TableCell></TableRow>}
          </TableBody>
        </Table>
      </CardContent></Card>
    </div>
  );
}
